import { render } from "./AbtestTimezoneResultPage.vue?vue&type=template&id=cdc88e32"
import script from "./AbtestTimezoneResultPage.vue?vue&type=script&lang=js"
export * from "./AbtestTimezoneResultPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__